/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsTagsSystem extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsTagsSystem");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsTagsSystem.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsTagsSystem>): AdditionalResourceDetailsForFinopsTagsSystem {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsTagsSystem(), model);
        AdditionalResourceDetailsForFinopsTagsSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsTagsSystem>): AdditionalResourceDetailsForFinopsTagsSystem {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsTagsSystem.newInstance(<AdditionalResourceDetailsForFinopsTagsSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsTagsSystem) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsTagsSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsTagsSystem): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsTagsSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.tagged_cost === undefined) {
            this.tagged_cost = 0;
        }
        if (this.untagged_cost === undefined) {
            this.untagged_cost = 0;
        }
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * total cost which has been tagged
     */
    tagged_cost: number;

    /**
     * total cost which has been untagged
     */
    untagged_cost: number;

}
